import React from "react";
import { Helmet } from "react-helmet-async";
import Design from "./assets/image/design.png";
import customdesign from "./assets/image/customdesign.png";
import WebsiteMaintenance from "./assets/image/Website-mintenance.png";
import ECommerce from "./assets/image/E-Commerce.png";
import Social from "./assets/image/Social.png";
import Secure from "./assets/image/Secure.png";

const Ourservices = () => {
  return (
    <>
      {/* SEO meta tags */}
      <Helmet>
        <title>9R NFC Card - High-Quality NFC Cards for Your Business</title>
        <meta
          name="description"
          content="Explore the best 9R NFC Card services. Our high-quality, customizable NFC cards are ideal for businesses looking to enhance customer experience and branding."
        />
        <meta name="keywords" content="9R NFC Card, NFC cards, custom NFC cards, business NFC solutions, high-quality NFC cards" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.yourwebsite.com/9r-nfc-card" />
      </Helmet>

      <section className="bg-white pt-35 pb-35">
        <div className="container">
          <div className="row pb-10 d-flex justify-content-center ">
            <div className="col-md-10 mb-20 text-center">
              <h2 className="fw-semibold pt-0">Our Services</h2>
            </div>
          </div>
          <div className="row text-center layout">
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="shadow-box p-3 d-flex h-100">
                <div className="card-body text-center">
                  <img
                    src={Design}
                    className="pb-20 w-25"
                    alt="9R NFC Card Design"
                  />
                  <h4 className="fs-5 fw-500 mb-2 text-dark">Quality NFC Cards</h4>
                  <p className="lh-sm fw-light">
                    We offer high-quality 9R NFC Cards made from durable materials, with precision printing and personalization options.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="shadow-box p-3 d-flex h-100">
                <div className="card-body text-center">
                  <img
                    src={customdesign}
                    className="pb-20 w-25"
                    alt="Custom NFC Card Designs"
                  />
                  <h4 className="fs-5 fw-500 mb-2 text-dark">Customizable Designs</h4>
                  <p className="lh-sm fw-light">
                    Customize your 9R NFC Cards with logos, brand colors, and other designs to match your business identity.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="shadow-box p-3 d-flex h-100">
                <div className="card-body text-center">
                  <img
                    src={WebsiteMaintenance}
                    className="pb-20 w-25"
                    alt="9R NFC Card Website Maintenance"
                  />
                  <h4 className="fs-5 fw-500 mb-2 text-dark">Variety of NFC Cards</h4>
                  <p className="lh-sm fw-light">
                    Our 9R NFC Cards come in various formats, with the latest technology to cater to different business needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="shadow-box p-3 d-flex h-100">
                <div className="card-body text-center">
                  <img
                    src={ECommerce}
                    className="pb-20 w-25"
                    alt="E-Commerce NFC Cards"
                  />
                  <h4 className="fs-5 fw-500 mb-2 text-dark">
                    NFC Cards for E-Commerce
                  </h4>
                  <p className="lh-sm fw-light">
                    Enhance your e-commerce experience with NFC cards that are easy to integrate with your online store.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="shadow-box p-3 d-flex h-100">
                <div className="card-body text-center">
                  <img
                    src={Social}
                    className="pb-20 w-25"
                    alt="Social Media for NFC Cards"
                  />
                  <h4 className="fs-5 fw-500 mb-2 text-dark">Strong Online Presence</h4>
                  <p className="lh-sm fw-light">
                    With a solid social media presence, we help promote and support your 9R NFC Cards to a wider audience.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="shadow-box p-3 d-flex h-100">
                <div className="card-body text-center">
                  <img
                    src={Secure}
                    className="pb-20 w-25"
                    alt="Secure NFC Cards"
                  />
                  <h4 className="fs-5 fw-500 mb-2 text-dark">Secure NFC Cards</h4>
                  <p className="lh-sm fw-light">
                    Our NFC Cards are built with robust security features to ensure that your business and customers are protected.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ourservices;
